// @flow
import React, { useState, useEffect, useCallback } from 'react';
import DesktopAppInstalledComponent from './DesktopAppInstalledComponent';
import { isMobile } from '../utils';
import * as segment from '../utils/segment';

export default ({ newUser }: { newUser?: boolean }) => {
  const [checkDesktopAppInstalled, setCheckDesktopAppInstalled] = useState(false);

  useEffect(() => {
    // If we're already in app, do nothing
    if (window.isElectron) {
      return;
    }
    if (isMobile()) {
      // On mobile, immediatly
      // let branch do the work
      window.open('https://ava.app.link/download');
    } else {
      // On desktop web, use
      // our custom app detector
      setCheckDesktopAppInstalled(true);
    }
  }, [isMobile]);

  const handleDesktopAppIsInstalled = useCallback(
    isInstalled => {
      setCheckDesktopAppInstalled(false);
      if (!isInstalled) {
        // If app is not installed, open
        // desktop app download link
        window.open('/download');
        segment.track('Desktop App Downloaded');
      }
    },
    [setCheckDesktopAppInstalled]
  );

  return checkDesktopAppInstalled ? (
    <DesktopAppInstalledComponent desktopAppInstalledOrNot={handleDesktopAppIsInstalled} newUser={newUser} />
  ) : null;
};
